module.exports = __webpack_public_path__ + "img/no-data.aff9e79.png";